<mat-progress-bar mode="indeterminate" *ngIf="spinner.isVisible()"></mat-progress-bar>
<app-scroll-to-bottom></app-scroll-to-bottom>
<app-header></app-header>
<router-outlet></router-outlet>
<app-footer ></app-footer>


